// TypeAheadDropDown.js
import { UuiSearchInput } from '@aonunited/react';
import './AonCustomSearch.scss';
import React, { useEffect, useState } from 'react';
export var AonCustomSearchDropDown = function (props) {
    var _a = useState(false), inputOnFocus = _a[0], setInputOnFocus = _a[1];
    useEffect(function () {
        var InputListner = function (Event) {
            if (Event.key === "Enter") {
                console.log("Test");
                props.handleText(Event.target.value, true);
            }
        };
        var inputRef = document.getElementById("__clientSearchInput__");
        if (inputRef) {
            inputRef.addEventListener("keydown", InputListner);
        }
        return function () {
            inputRef.removeEventListener("keydown", InputListner);
        };
    }, []);
    var onTextChange = function (e) {
        props.handleText(e.detail, false);
    };
    var handleClear = function () {
        props.handleText("", false);
    };
    var suggestionSelected = function (value) {
        props.onSelectOption(value);
        setInputOnFocus(false);
    };
    var renderSuggestions = function () {
        return (React.createElement("ul", null, props.allOptions.map(function (city) { return React.createElement("li", { key: city.lable, onClick: function (e) { return suggestionSelected(city.value); } }, city.lable); })));
    };
    var handleFocus = function () {
        setInputOnFocus(true);
    };
    var handleBlur = function () {
        //setInputOnFocus(false)
    };
    return (React.createElement("div", { className: "TypeAheadDropDown", onFocus: handleFocus, onBlur: handleBlur },
        React.createElement("div", { className: 'input-box' },
            React.createElement(UuiSearchInput, { id: "__clientSearchInput__", onCleartext: handleClear, fetching: props.fetching, onTextchange: onTextChange, placeholder: "Search for Client...", value: props.searchValue, type: "text" })),
        React.createElement("div", { className: 'ul-list-box' }, inputOnFocus ? renderSuggestions() : null)));
};
